import styled from 'styled-components';

const UpdatedMobileMenuStyles = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  max-height: 75vh;

  .nav-section {
    background: ${props => props.theme.colors.grey7};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    height: 40px;

    a {
      padding: 0;
      margin: 0;
      color: ${props => props.theme.colors.bedtime};
    }
  }

  .bottom-nav {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    padding: 1.25rem 2.1875rem;
  }

  .nav-item {
    width: 100%;
    text-decoration: none;
    color: ${props => props.theme.colors.grey1};

    .container {
      display: flex;
      width: 100%;
      justify-content: space-between;

      svg {
        color: ${props => props.theme.colors.grey1};
      }

      .caret-down {
        transform: rotate(-90deg);
      }

      .caret-up {
        transform: rotate(180deg);
      }
    }

    .content {
      margin-left: 0.9375rem;
    }
  }

  .nav-item.active {
    display: flex;
    width: 100%;
    justify-content: space-between;

    svg {
      transform: rotate(-90deg);
    }
  }

  .dropdown {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${props => props.theme.colors.grey6};
    padding: 0.3125rem 0;
  }

  .dropdown-link {
    text-decoration: none;
    color: ${props => props.theme.colors.grey2};
  }

  .button-links {
    padding: 0 1rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default UpdatedMobileMenuStyles;
